import { render, staticRenderFns } from "./BotWeddingEventListCard.vue?vue&type=template&id=4fb35021"
import script from "./BotWeddingEventListCard.vue?vue&type=script&lang=ts"
export * from "./BotWeddingEventListCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports